<template>
  <div class="impact-bar" :class="{ selected, loading }"
       :content="`Real impact: ${real}%<br>Potential impact: ${potential}%`" v-tippy>
    <div class="inner">
      <div class="bar positive real" :class="[ positive ? 'positive' : 'negative' ]"
           :style="`width: ${real}%`"></div>
      <div class="bar positive potential" :class="[ positive ? 'positive' : 'negative' ]"
           :style="`width: ${potential}%`"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImpactBar',
    props: {
      // Impact is given in percentage of total document size
      real: Number,
      potential: Number,
      positive: Boolean,
      selected: Boolean,
      loading: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  @use '../styles/variables' as v

  @keyframes loading
    0%
      left: -100%
    100%
      left: 100%

  .impact-bar
    width: 100%
    height: 16px
    position: relative
    cursor: pointer
    overflow: hidden
    box-shadow: 0 0 1px black

    .inner
      width: 100%
      height: 100%
      position: relative
      background: v.$dark-gray

      .bar
        height: 100%
        position: absolute
        left: 0
        top: 0

        &.potential
          background: v.$impact-potential

        &.real
          z-index: 2

          &.positive
            background: v.$impact-real-positive

          &.negative
            background: v.$impact-real-negative

    &.selected
      .inner
        background: lighten(v.$dark-gray, 10)

      .bar.potential
        background: lighten(v.$impact-potential, 10)

      .bar.real.positive
        background: lighten(v.$impact-real-positive, 10)

      .bar.real.negative
        background: lighten(v.$impact-real-negative, 10)

    &.loading
      background: v.$dark-gray
      .inner
        background: linear-gradient(to right, transparent 20%, v.$gray2, transparent 80%)
        animation: loading 1.8s cubic-bezier(0.4, 0, 0.2, 1) infinite

      .bar
        display: none

</style>
